// src/utils/auth.ts
export const isAdminMode = () => {
  return window.location.pathname.endsWith('/admin');
};